const PatternTokenizer = require("./patternTokenizer");
class NumberTokenizer extends PatternTokenizer {
    constructor() {
        super("number", /^(?!0\d)\d*(\.\d+)?$/);
    }

    parse(tokens, current) {
        return [current + 1,
            {
                type: 'NumberLiteral',
                value: tokens[current].value,
                getInterpolatedValue: this.interpolateValue.bind(this, parseFloat(tokens[current].value)),
                params: []
            }];
    }
}

module.exports = NumberTokenizer;